import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { GetContractingCorporationProfileResponse, SaveCorporateProfileRequest, SaveRegistrationRequest } from './type';

/**
 * 契約企業情報取得
 */
export async function getContractingCorporationProfile(): Promise<GetContractingCorporationProfileResponse> {
  const res = await apiClient.GET('/v2/contracting-corporation-profile');
  return getDataOrThrowApiError(res);
}

/**
 * 企業概要更新
 */
export async function saveCorporateProfile(data: SaveCorporateProfileRequest): Promise<void> {
  const res = await apiClient.POST('/v2/contracting-corporation-profile/corporate-profile', {
    body: data
  });
  getDataOrThrowApiError(res);
}

/**
 * 登記情報更新
 */
export async function saveRegistration(data: SaveRegistrationRequest): Promise<void> {
  const res = await apiClient.POST('/v2/contracting-corporation-profile/registration', {
    body: data
  });
  getDataOrThrowApiError(res);
}